// extracted by mini-css-extract-plugin
export var menuIcon = "_u5-0";
export var menuIconInline = "_u5-1";